import React, { createContext, useContext, useEffect, useState } from 'react';
import { translations } from '../data/translations';
import type { TranslationKey } from '../data/translations';
import type { Lang } from '../types/cart';
type LanguageContextValue = {
  lang: Lang;
  setLang: (l: Lang) => void;
  t: (key: TranslationKey) => string;
};
const LanguageContext = createContext<LanguageContextValue | null>(null);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [lang, setLang] = useState<Lang>(() => {
    if (typeof window === 'undefined') return 'en';
    return localStorage.getItem('mfl-lang') as Lang || 'en';
  });
  useEffect(() => {
    localStorage.setItem('mfl-lang', lang);
    document.documentElement.lang = lang === 'es' ? 'es' : 'en-US';
  }, [lang]);
  const t = (key: TranslationKey) => translations[lang][key] ?? translations.en[key];
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-977" data-mp="2jkoxog9okz60">{children}</LanguageContext.Provider>;
}
export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}